module.exports = __webpack_public_path__ + "static/media/leia.db5e6aa8.jpg";